<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="500px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="考生姓名"
                      prop="exam_student_name">
          <el-input v-model="dataForm.exam_student_name"
                    placeholder="请输入考生姓名"></el-input>
        </el-form-item>
        <el-form-item label="考生编号"
                      prop="exam_student_no">
          <el-input v-model="dataForm.exam_student_no"
                    placeholder="请输入考生编号"></el-input>
        </el-form-item>
        <el-form-item label="科目一成绩"
                      prop="exam_score_politics">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.exam_score_politics">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="科目二成绩"
                      prop="exam_score_language">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.exam_score_language">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="科目三成绩"
                      prop="exam_score_business_1">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.exam_score_business_1">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="科目四成绩"
                      prop="exam_score_business_2">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.exam_score_business_2">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="总分"
                      prop="exam_score_total">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.exam_score_total">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="dataForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <div style="display:flex; justify-content: flex-end;marginTop:30px">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  secondExamRosterCreated,
  secondExamRosterDetail,
  secondExamRosterPut,
} from '@/api/admission'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建复试名单'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        exam_student_name: [
          { required: true, message: '请输入考生姓名', trigger: 'blur' },
        ],
        exam_student_no: [
          { required: true, message: '请输入考生编号', trigger: 'blur' },
        ],
        exam_score_politics: [
          { required: true, message: '请输入科目一成绩', trigger: 'blur' },
        ],
        exam_score_language: [
          { required: true, message: '请输入科目二成绩', trigger: 'blur' },
        ],
        exam_score_business_1: [
          { required: true, message: '请输入科目三成绩', trigger: 'blur' },
        ],
        exam_score_business_2: [
          { required: true, message: '请输入科目四成绩', trigger: 'blur' },
        ],
        exam_score_total: [
          { required: true, message: '请输入成绩总分', trigger: 'blur' },
        ],
      },
      dataForm: {
        exam_student_name: '',
        exam_student_no: '',
        exam_score_politics: '',
        exam_score_language: '',
        exam_score_business_1: '',
        exam_score_business_2: '',
        exam_score_total: '',
        remark: '',
      },
      rowDetail: {},
    }
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.dataForm = {
        // exam_student_name: '',
        // exam_student_no: '',
        // exam_score_politics: '',
        // exam_score_language: '',
        // exam_score_business_1: '',
        // exam_score_business_2: '',
        // exam_score_total: '',
        // remark: '',
      }
      this.$refs['dataForm'].resetFields()
    },
    open() {
      if (this.title == '编辑复试名单') {
        secondExamRosterDetail({ id: this.rowId }).then((res) => {
          console.log('res', res)
          this.rowDetail = res
          this.$set(this.dataForm, 'exam_student_name', res.exam_student_name)
          this.$set(this.dataForm, 'exam_student_no', res.exam_student_no)
          this.$set(
            this.dataForm,
            'exam_score_politics',
            res.exam_score_politics
          )
          this.$set(
            this.dataForm,
            'exam_score_language',
            res.exam_score_language
          )
          this.$set(
            this.dataForm,
            'exam_score_business_1',
            res.exam_score_business_1
          )
          this.$set(
            this.dataForm,
            'exam_score_business_2',
            res.exam_score_business_2
          )
          this.$set(this.dataForm, 'exam_score_total', res.exam_score_total)
          this.$set(this.dataForm, 'remark', res.remark)
        })
      }
    },
    handleSubmit() {
      console.log('this.detail', this.detail)
      console.log('this.dataform', this.dataForm)
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新建复试名单') {
            let data = {
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              second_exam_college_code: this.detail.college_code,
              second_exam_college_name: this.detail.college_name,
              second_exam_academy_code: this.detail.academy_code,
              second_exam_academy_name: this.detail.academy_name,
              second_exam_major_code: this.detail.major_code,
              second_exam_major_name: this.detail.major_name,
              second_exam_enrol_type: '1',
              exam_score_total: this.dataForm.exam_score_total,
              exam_score_politics: this.dataForm.exam_score_politics,
              exam_score_language: this.dataForm.exam_score_language,
              exam_score_business_1: this.dataForm.exam_score_business_1,
              exam_score_business_2: this.dataForm.exam_score_business_2,
              remark: this.dataForm.remark,
            }
            secondExamRosterCreated(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            let data = {
              id: this.rowDetail.id,
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              second_exam_college_code: this.detail.college_code,
              second_exam_college_name: this.detail.college_name,
              second_exam_academy_code: this.detail.academy_code,
              second_exam_academy_name: this.detail.academy_name,
              second_exam_major_code: this.detail.major_code,
              second_exam_major_name: this.detail.major_name,
              second_exam_enrol_type: '1',
              exam_score_total: this.dataForm.exam_score_total,
              exam_score_politics: this.dataForm.exam_score_politics,
              exam_score_language: this.dataForm.exam_score_language,
              exam_score_business_1: this.dataForm.exam_score_business_1,
              exam_score_business_2: this.dataForm.exam_score_business_2,
              remark: this.dataForm.remark,
            }
            secondExamRosterPut(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
</style>
